// DelUnit.js
// Containing the classes for Units, Misc Units, and Rental Units
import { v4 as uuidv4 } from "uuid";

// Unit Class, for EWI Units
export class DelUnit {
  constructor(data = {}) {
    this.rowId = data.id || uuidv4();
    this.unitId = data.unit_id || null;
    this.unitName = data.unit_id
      ? data.unit_id + " - " + data.unit_name
      : data.unit_name || null;
    this.unitType = data.unit_type || null;
    this.billableUnits = data.billable_units || null;
    this.unitPlural = data.plural_label || null;
    this.unitTypeName = data.del_unit_type || null;
  }

  updateUnitType(unitType) {
    this.unitType = unitType;
  }

  updateUnitTypeName(unitTypeName) {
    this.unitTypeName = unitTypeName;
  }

  updateUnitNameIdPlural(unitName, unitId, unitPlural, unitType, unitTypeName) {
    this.unitName = unitName;
    this.unitId = unitId;
    this.unitPlural = unitPlural;
    this.unitType = unitType;
    this.unitTypeName = unitTypeName;
  }

  updateUnitQuantity(quantity) {
    this.billableUnits = quantity;
  }

  // To json for sending to the database
  toJson() {
    return {
      id: this.rowId,
      unit_id: this.unitId,
      billable_units: this.billableUnits,
      del_unit_type: this.unitTypeName,
    };
  }

  toPatch(action, fields) {
    const fieldMap = {
      unitId: "unit_id",
      billableUnits: "billable_units",
      unitTypeName: "del_unit_type",
    };
    const patch = {
      patch_type: "unit",
      action: action,
      id: this.rowId,
    };
    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }
    return patch;
  }
}

// Misc Equipment Class, for Misc Equipment that may be added to the DEL form
export class MiscEquip {
  constructor(data = {}) {
    this.rowId = data.id || uuidv4();
    this.unitName = data.unit_name || null;
    this.quantity = data.quantity || null;
    this.quantityType = data.quantity_type || null;
    this.vendor = data.vendor || null;
  }

  // Updating the unit name
  updateUnitName(unitName) {
    this.unitName = unitName;
  }

  // Updating the quantity
  updateQuantity(quantity) {
    this.quantity = quantity;
  }

  // Updating the quantity type
  updateQuantityType(quantityType) {
    this.quantityType = quantityType;
  }

  // Updating the vendor
  updateVendor(vendor) {
    this.vendor = vendor;
  }

  // To json for sending to the database
  toJson() {
    return {
      id: this.rowId,
      unit_name: this.unitName,
      quantity: this.quantity,
      quantity_type: this.quantityType,
      vendor: this.vendor,
    };
  }

  toPatch(action, fields) {
    const fieldMap = {
      unitName: "unit_name",
      quantity: "quantity",
      quantityType: "quantity_type",
      vendor: "vendor",
    };
    const patch = {
      patch_type: "misc_unit",
      action: action,
      id: this.rowId,
    };
    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }
    return patch;
  }
}

// Rental Equipment Class, for Rental Equipment that may be added to the DEL form
export class RentalEquip {
  constructor(data = {}) {
    this.rowId = data.id || uuidv4();
    this.itemName = data.item_name || null;
    this.quantity = data.quantity || null;
    this.quantityType = data.quantity_type || null;
    this.vendor = data.vendor || null;
  }

  // Updating the unit name
  updateUnitName(itemName) {
    this.itemName = itemName;
  }

  // Updating the quantity
  updateQuantity(quantity) {
    this.quantity = quantity;
  }

  // Updating the quantity type
  updateQuantityType(quantityType) {
    this.quantityType = quantityType;
  }

  // Updating the vendor
  updateVendor(vendor) {
    this.vendor = vendor;
  }

  // To json for sending to the database
  toJson() {
    return {
      id: this.rowId,
      item_name: this.itemName,
      quantity: this.quantity,
      quantity_type: this.quantityType,
      vendor: this.vendor,
    };
  }

  toPatch(action, fields) {
    const fieldMap = {
      itemName: "item_name",
      quantity: "quantity",
      quantityType: "quantity_type",
      vendor: "vendor",
    };
    const patch = {
      patch_type: "rental_unit",
      action: action,
      id: this.rowId,
    };
    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }
    return patch;
  }
}
